export default __webpack_public_path__ + "static/media/solucao-08.562dbbb0.webp";